import React from 'react';
import { Auth } from 'aws-amplify';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { RouteProps } from 'react-router';

import { getProfileClientPath, getUserDetailPath } from 'routing/paths';
import { RoutesContext } from 'utils/routing';

import { State as userProfileState } from 'reducers/user-profile';
import { RootState } from 'reducers';

// components
import {
  AppBar,
  Toolbar,
  CssBaseline,
  Divider,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Breadcrumbs
} from '@material-ui/core';

import {
  AccountCircle,
  ExitToApp,
  SettingsApplications,
  Menu as MenuIcon,
  NavigateNext,
} from '@material-ui/icons';
import BusinessIcon from '@material-ui/icons/Business';

import MainMenu from '../MainMenu';
import { renderBreadcrumbsEntries, renderBreadcrumbsEntriesMobile } from './utils';
// styles
import useStyles from './HeaderStyle';

interface Props {
  user: userProfileState;
}

const mapStateToProps = (state: RootState) => ({
  user: state.user
});

const Component = (props: RouteProps & Props) => {
  const classes = useStyles();
  const { user } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  function handleMenu(event: React.MouseEvent<HTMLElement>) {
    setAnchorEl(event.currentTarget);
  }

  function handleClose() {
    setAnchorEl(null);
  }

  const [stateMenu, setStateMenu] = React.useState<boolean>(false);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event &&
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }

    setStateMenu(open);
  };

  const pathname = props && props.location && props.location.pathname;
  const userName = props.user.data.first_name && props.user.data.last_name ?
    `Hello, ${props.user.data.first_name} ${props.user.data.last_name}` :
    props.user.data.email;

  return (
    <>
      <CssBaseline />
      <AppBar position="fixed" className={ classes.appBar } color="primary" data-testid="app-header">
        <Toolbar>
          <IconButton
            data-testid="main-menu-icon"
            edge="start"
            className={ classes.menuButton }
            onClick={ toggleDrawer(!stateMenu) }
          >
            <MenuIcon />
          </IconButton>
          <RoutesContext.Consumer>
            { routes => pathname && routes && <>
              <Breadcrumbs
                classes={{
                  root: clsx(classes.title, classes.mobileHeader),
                  ol: classes.breadcrumbs,
                  li: classes.breadcrumb,
                  separator: classes.breadcrumbSeparator,
                }}
                separator={ <NavigateNext fontSize="small" /> }
              >
                { renderBreadcrumbsEntriesMobile({ pathname, routes }) }
              </Breadcrumbs>
              <Breadcrumbs
                classes={{
                  root: clsx(classes.title, classes.desktopHeader),
                  ol: classes.breadcrumbs,
                  li: classes.breadcrumb,
                  separator: classes.breadcrumbSeparator,
                }}
                separator={ <NavigateNext fontSize="small" /> }
              >
                { renderBreadcrumbsEntries({ pathname, routes }) }
              </Breadcrumbs>
            </> }
          </RoutesContext.Consumer>
          { user.signedIn && props.user.data.sub && (
            <div>
              <IconButton onClick={ handleMenu }>
                <AccountCircle className={ classes.title } />
              </IconButton>
              <Menu
                anchorEl={ anchorEl }
                anchorOrigin={ {
                  vertical: 'top',
                  horizontal: 'right',
                } }
                keepMounted={ true }
                transformOrigin={ {
                  vertical: 'top',
                  horizontal: 'right',
                } }
                open={ open }
                onClose={ handleClose }
              >
                <MenuItem>
                  <ListItemIcon>
                    <AccountCircle color="primary" />
                  </ListItemIcon>
                  <ListItemText
                    primary={ userName }
                    secondary={
                      <React.Fragment>
                        <Typography variant="caption">{ props.user.data.role }</Typography>
                      </React.Fragment>
                    }
                  />
                </MenuItem>
                <Divider />
                <MenuItem
                  component={ Link }
                  to={ getUserDetailPath(props.user.data.sub) }
                  onClick={ handleClose }
                >
                  <ListItemIcon>
                    <SettingsApplications color="primary" />
                  </ListItemIcon>
                  <Typography>Profile</Typography>
                </MenuItem>
                <MenuItem component={ Link } to={ getProfileClientPath() } onClick={ handleClose }>
                  <ListItemIcon><BusinessIcon color="primary" /></ListItemIcon>
                  <Typography>Company Info</Typography>
                </MenuItem>
                <MenuItem onClick={ () => Auth.signOut() }>
                  <ListItemIcon>
                    <ExitToApp color="primary" />
                  </ListItemIcon>
                  <Typography>Sign out</Typography>
                </MenuItem>
              </Menu>
            </div>
          ) }
        </Toolbar>
      </AppBar>

      <MainMenu
        swipeableDrawerProps={ {
          open: stateMenu,
          onClose: toggleDrawer(false),
          onOpen: toggleDrawer(true),
        } }
      />
    </>
  );
};

export default withRouter(connect(
  mapStateToProps
)(Component));
